<template>
  <div class="d-flex align-center" style="width: 110px">
    <v-btn
      :disabled="quantity <= 1"
      min-width="30"
      small
      text
      color="primary"
      class="pa-0"
      @click="onClick('decrease')"
    >
      <v-icon small color="primary">
        mdi-minus
      </v-icon>
    </v-btn>
    <v-text-field
      v-model.number="quantity"
      dense
      class="quantity-input"
      solo
      flat
      hide-details
      type="number"
      min="1"
      @input="onInput"
    >
      {{ quantity }}
    </v-text-field>
    <v-btn
      :disabled="lockQuantity ? quantity >= available : false"
      min-width="30"
      small
      text
      color="primary"
      class="pa-0"
      @click="onClick('increase')"
    >
      <v-icon small color="primary">
        mdi-plus
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
import isFinite from "lodash/isFinite";

export default {
  name: "ButtonCounter",
  props: {
    item: {
      type: Object
    },
    lockQuantity: {
      type: Boolean,
      default: true
    }
  },
  data: () => ({
    quantity: 1
  }),
  watch: {
    "item.quantity"(value) {
      this.quantity = value;
    }
  },
  created() {
    this.quantity = this.item.quantity;
  },
  computed: {
    available() {
      return this.item.available;
    }
  },
  methods: {
    onInput(value) {
      const formattedValue = parseInt(value, 10);
      if (!isFinite(formattedValue) || formattedValue < 1) {
        this.quantity = 1;
      }
      this.$emit("input", this.quantity);
    },
    onClick(type) {
      if (!isFinite(this.quantity) || this.quantity < 1) this.quantity = 1;
      if (type === "increase") this.quantity = this.quantity + 1;
      if (type === "decrease") this.quantity = this.quantity - 1;
      this.$emit("input", this.quantity);
    }
  }
};
</script>

<style lang="scss">
input[type="number"]::-webkit-inner-spin-button,
input[type="number"]::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.quantity-input input {
  text-align: center;
}
</style>
